import { VENDOR_KEY_BY_TYPENAME } from "constants/vendor";
import {
  Hooks,
  Maybe,
  Stack,
  StackConfigVendor,
  StackConfigVendorInput,
  StackInput,
} from "types/generated";
import { EMPTY_STACK_CONFIG_VENDOR_INPUT } from "constants/stack";

const prepareVendorConfigWithoutAnyChanges = (
  vendorConfig: Maybe<StackConfigVendor>
): StackConfigVendorInput => {
  const { __typename, ...vendorFields } = vendorConfig || {};
  const vendor = __typename && VENDOR_KEY_BY_TYPENAME[__typename];

  return {
    ...EMPTY_STACK_CONFIG_VENDOR_INPUT,
    ...(vendor && {
      [vendor]: vendorFields,
    }),
  };
};

type StackToUpdate = Omit<Stack, "hooks"> & { hooks?: Hooks };

export const makeStackUpdateInput = (
  stack: StackToUpdate,
  { vendorConfig: newVendorConfig, ...stackChanges }: Partial<StackInput>
): StackInput => {
  const vendorConfig = newVendorConfig || prepareVendorConfigWithoutAnyChanges(stack.vendorConfig);
  const hooks = stack.hooks;

  return {
    additionalProjectGlobs: stack.additionalProjectGlobs,
    administrative: stack.administrative,
    afterApply: hooks?.afterApply ?? null,
    afterDestroy: hooks?.afterDestroy ?? null,
    afterInit: hooks?.afterInit ?? null,
    afterPerform: hooks?.afterPerform ?? null,
    afterPlan: hooks?.afterPlan ?? null,
    afterRun: hooks?.afterRun ?? null,
    autodeploy: stack.autodeploy,
    autoretry: stack.autoretry,
    beforeApply: hooks?.beforeApply ?? null,
    beforeDestroy: hooks?.beforeDestroy ?? null,
    beforeInit: hooks?.beforeInit ?? null,
    beforePerform: hooks?.beforePerform ?? null,
    beforePlan: hooks?.beforePlan ?? null,
    branch: stack.branch,
    description: stack.description,
    enableWellKnownSecretMasking: stack.enableWellKnownSecretMasking,
    enableSensitiveOutputUpload: stack.enableSensitiveOutputUpload,
    githubActionDeploy: stack.githubActionDeploy,
    gitSparseCheckoutPaths: stack.gitSparseCheckoutPaths,
    isDisabled: stack.isDisabled,
    labels: stack.labels,
    localPreviewEnabled: stack.localPreviewEnabled,
    name: stack.name,
    namespace: stack.provider === "GITHUB" ? null : stack.namespace,
    projectRoot: stack.projectRoot,
    protectFromDeletion: stack.protectFromDeletion,
    provider: stack.provider,
    repository: stack.repository,
    repositoryURL: stack.repositoryURL,
    runnerImage: stack.runnerImage,
    skipVendorBinaryDownload: stack.skipVendorBinaryDownload,
    space: stack.spaceDetails.id,
    terraformVersion: stack.terraformVersion,
    vcsIntegrationId: stack.vcsIntegration?.id || null,
    workerPool: stack.workerPool ? stack.workerPool.id : null,
    ...stackChanges,
    vendorConfig,
  };
};
